import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import React, { useState } from "react";
import { formatCurrency, formatDate } from "../../../utils/utils";
import { tableCellStyles, tableHeaderStyles } from "../../../utils/styles";

const TripDetails = ({ data }: { data: any }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const records = data?.records || [];
  const paginatedRecords = records.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeaderStyles}>From Location</TableCell>
              <TableCell sx={tableHeaderStyles}>To Location</TableCell>
              <TableCell sx={tableHeaderStyles}>Trip Type</TableCell>
              <TableCell sx={tableHeaderStyles}>Journey Date</TableCell>
              <TableCell sx={tableHeaderStyles}>Income</TableCell>
              <TableCell sx={tableHeaderStyles}>Expense</TableCell>
              <TableCell sx={tableHeaderStyles}>Commission</TableCell>
              <TableCell sx={tableHeaderStyles}>Net Income</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRecords.length > 0 ? (
              paginatedRecords.map((trip: any) => (
                <TableRow key={trip.tripId}>
                  <TableCell sx={tableCellStyles}>
                    {trip.fromLocation}
                  </TableCell>
                  <TableCell sx={tableCellStyles}>{trip.toLocation}</TableCell>
                  <TableCell sx={tableCellStyles}>{trip.tripType}</TableCell>
                  <TableCell sx={tableCellStyles}>
                    {formatDate(trip.journeyStartDate)}
                    {trip.journeyReturnDate &&
                      ` - ${formatDate(trip.journeyReturnDate)}`}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles, color: "success.main" }}>
                    {formatCurrency(trip.totalIncome)}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles, color: "error.main" }}>
                    {formatCurrency(trip.totalExpense)}
                  </TableCell>
                  <TableCell sx={{ ...tableCellStyles, color: "error.main" }}>
                    {formatCurrency(trip.totalCommission)}
                  </TableCell>
                  <TableCell
                    sx={{
                      ...tableCellStyles,
                      color:
                        trip.totalIncome -
                          trip.totalExpense -
                          trip.totalCommission >
                        0
                          ? "success.main"
                          : "error.main",
                    }}
                  >
                    {formatCurrency(trip.totalIncome - trip.totalExpense)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: "center" }}>
                  No trip found for this vehicle
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {records.length > 10 && (
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={records.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
        />
      )}
    </Paper>
  );
};

export default TripDetails;
